import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api, { RBAC_BASE } from '../../../api/rbacApi';

const RoleAssign = () => {
	const { userId } = useParams();
	const navigate = useNavigate();

	const [users, setUsers] = useState([]);
	const [roles, setRoles] = useState([]);
	const [selectedUser, setSelectedUser] = useState('');
	const [selectedRoles, setSelectedRoles] = useState([]);
	const [loading, setLoading] = useState(false);

	useEffect(() => {
		load();
	}, []);

	useEffect(() => {
		if (userId) {
			setSelectedUser(userId);
		}
	}, [userId]);

	const load = async () => {
		try {
			const [u, r] = await Promise.all([
				api.get(`${RBAC_BASE}/user-role-mapping`),
				api.get(`${RBAC_BASE}/roles`)
			]);

			setUsers(u.data);
			setRoles(r.data);

			// Prefill role if userId exists
			if (userId) {
				const user = u.data.find(x => x.intUserId == userId);
				if (user) {
					setSelectedUser(user.intUserId);
					setSelectedRoles([
						...new Set([
							u.intDesigId,
							...(u.extraRoles || [])
						])
					]);
				}
			}

		} catch (err) {
			console.error(err);
		}
	};

	const handleSave = async () => {
		if (!selectedUser) {
			alert("Please select user");
			return;
		}

		try {
			setLoading(true);

			await api.post(`${RBAC_BASE}/assign-role`, {
				userId: selectedUser,
				roleIds: selectedRoles
			});

			alert("Role assigned successfully");

			navigate('/role-access-list');

		} catch (err) {
			console.error(err);
			alert("Error assigning role");
		} finally {
			setLoading(false);
		}
	};

	const toggleRole = (roleId) => {
		setSelectedRoles(prev =>
			prev.includes(roleId)
				? prev.filter(r => r !== roleId)
				: [...prev, roleId]
		);
	};
	return (
		<div className="px-xl-5 px-lg-4 px-3 py-3 page-body">

			{/* HEADER */}
			<div className="sticky-top bg-white py-2 mb-3 border-bottom d-flex justify-content-between align-items-center">
				<h4 className="fw-bold mb-0">Assign Role to User</h4>

				<button
					className="btn btn-primary px-4"
					onClick={handleSave}
					disabled={loading}
				>
					{loading ? "Saving..." : "Save"}
				</button>
			</div>

			<div className="card shadow-sm border-0">
				<div className="card-body">
					{selectedUser && (
						<div className="alert alert-light border mb-3">
							User: <strong>
								{users.find(u => u.intUserId == selectedUser)?.vchFullName}
							</strong>
						</div>
					)}
					<div className="row">

						{/* LEFT: USER LIST */}
						<div className="col-md-4">
							<div className="card shadow-sm h-100">
								<div className="card-header fw-bold">Users</div>

								<div className="card-body p-2" style={{ maxHeight: "500px", overflowY: "auto" }}>
									{users.map(u => (
										<div
											key={u.intUserId}
											className={`p-2 mb-2 rounded cursor-pointer ${selectedUser == u.intUserId ? "bg-primary text-white" : "bg-light"
												}`}
											style={{ cursor: "pointer" }}
											onClick={() => {
												setSelectedUser(u.intUserId);

												setSelectedRoles([
													u.intDesigId,
													...(u.extraRoles || [])
												]);
											}}
										>
											<div className="fw-semibold">{u.vchFullName}</div>
											<small>{u.vchEmail}</small>
										</div>
									))}
								</div>
							</div>
						</div>

						{/* RIGHT: ROLE CARDS */}
						<div className="col-md-8">
							<div className="card shadow-sm h-100">
								<div className="card-header fw-bold">Assign Role</div>

								<div className="card-body">
									{!selectedUser ? (
										<div className="text-muted">Select a user to assign role</div>
									) : (
										<div className="d-flex flex-wrap gap-2">

											{roles.map(r => {
												const primaryRole = users.find(u => u.intUserId == selectedUser)?.intDesigId;

												const isPrimary = r.intDesigId === primaryRole;
												const isSelected = selectedRoles.includes(r.intDesigId);

												return (
													<div
														key={r.intDesigId}
														onClick={() => !isPrimary && toggleRole(r.intDesigId)}
														className={`px-3 py-2 rounded-pill border ${isPrimary
															? "border-dark bg-dark text-white"
															: isSelected
																? "border-primary bg-light text-primary fw-semibold"
																: "border-light bg-light"
															}`}
														style={{
															cursor: isPrimary ? "not-allowed" : "pointer",
															fontSize: "13px",
															transition: "all 0.2s ease",
															opacity: isPrimary ? 0.8 : 1
														}}
													>
														{r.nvchDesigName}
														{isPrimary && <span className="ms-1">(Primary)</span>}
													</div>
												);
											})}

										</div>
									)}
								</div>
							</div>
						</div>
					</div>

				</div>
			</div>

		</div>
	);
};

export default RoleAssign;